/*@ngInject*/
const UiFormTemplateModel = function ($rootScope) {
    var uiFormTemplate,
        ruleType = 'formRule',
        selectedFieldRuleName;

    this.getUiFormTemplate = function () {
        return this.uiFormTemplate;
    };

    this.setUiFormTemplate = function (uiFormTemplate) {
        this.uiFormTemplate = uiFormTemplate;
    };

    this.setCurrentSelectedRule = function(ruleType) {
        this.ruleType = ruleType
    };

    this.getCurrentSelectedRule = function(ruleType) {
        return this.ruleType;
    };

    this.setSelectedFieldRuleName = function (selectedFieldRuleName) {
        this.selectedFieldRuleName = selectedFieldRuleName;
    };

    this.getSelectedFieldRuleName = function() {
        return this.selectedFieldRuleName;
    };

};

angular.module('umCore').service('uiFormTemplateModel', UiFormTemplateModel);
